var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import promiseSequential from 'promise-sequential';
import { getActivatedRoutes } from '../utils/get-activated-routes';
export var actionHandler = function (router) { return function (toState, fromState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, routes, store, parentError, getHandler, activatedRoutes, result;
    return __generator(this, function (_b) {
        _a = router.getDependencies(), routes = _a.routes, store = _a.store;
        parentError = null;
        getHandler = function (route) {
            return function () {
                return new Promise(function (resolve, reject) {
                    if (route.actionResult &&
                        route.actionResult.useCache === true &&
                        !parentError &&
                        !route.actionResult.error) {
                        // Use cache
                        resolve(route);
                    }
                    else if (parentError) {
                        // Parent has error
                        resolve(Object.assign(route, { actionResult: parentError }));
                    }
                    else if (typeof route.loadAction === 'function' ||
                        typeof route.action === 'function') {
                        // Get action promise
                        var actionPromise = void 0;
                        if (typeof route.loadAction === 'function') {
                            actionPromise = new Promise(function (resolveActionLoad) {
                                // eslint-disable-next-line
                                // @ts-ignore
                                route
                                    .loadAction()
                                    .then(function (loaded) {
                                    resolveActionLoad(loaded.default);
                                })
                                    .catch(reject);
                            });
                        }
                        else {
                            // eslint-disable-next-line
                            // @ts-ignore
                            actionPromise = Promise.resolve(route.action);
                        }
                        var actionParams_1 = {
                            router: router,
                            toState: toState,
                            fromState: fromState,
                            store: store,
                            externalParams: route.params,
                        };
                        // Run action promise
                        actionPromise.then(function (action) {
                            action(actionParams_1)
                                .then(function (result) {
                                if (result.error) {
                                    parentError = result.error;
                                    return Object.assign(route, {
                                        actionResult: result.error,
                                    });
                                }
                                return Object.assign(route, {
                                    actionResult: result,
                                });
                            })
                                .then(resolve)
                                .catch(reject);
                        });
                    }
                    else {
                        // No action fallback
                        resolve(Object.assign(route, { actionResult: null }));
                    }
                });
            };
        };
        activatedRoutes = getActivatedRoutes(toState, fromState, routes);
        result = activatedRoutes.reduce(function (acc, route, index, arr) {
            var newAcc = {
                result: __spreadArray([], acc.result, true),
                parallelStack: __spreadArray([], acc.parallelStack, true),
            };
            if (route.canParallel) {
                newAcc.parallelStack.push(getHandler(route));
                if (index === arr.length - 1) {
                    var copiedParallelPromises_1 = __spreadArray([], newAcc.parallelStack, true);
                    newAcc.result.push(function () {
                        return Promise.all(copiedParallelPromises_1.map(function (createPromise) { return createPromise(); }));
                    });
                    newAcc.parallelStack = [];
                }
            }
            else {
                if (newAcc.parallelStack.length > 0) {
                    var copiedParallelPromises_2 = __spreadArray([], newAcc.parallelStack, true);
                    newAcc.result.push(function () {
                        return Promise.all(copiedParallelPromises_2.map(function (createPromise) { return createPromise(); }));
                    });
                    newAcc.parallelStack = [];
                }
                newAcc.result.push(getHandler(route));
            }
            return newAcc;
        }, {
            result: [],
            parallelStack: [],
        }).result;
        // eslint-disable-next-line
        // @ts-ignore
        return [2 /*return*/, promiseSequential(result)];
    });
}); }; };
